import React, { useState, useEffect } from "react";
import { NavLink, useRouteMatch } from "react-router-dom";
import {
  makeStyles,
  Tooltip,
  Box,
  withStyles,
  Button,
} from "@material-ui/core";
import { FaHandshake } from "react-icons/fa";
import { BsArrowsAngleContract } from "react-icons/bs";
import {
  RiBubbleChartLine,
  RiHistoryLine,
  RiPriceTag3Line,
  RiCalendar2Line,
} from "react-icons/ri";
import { Auth } from "aws-amplify";
import { ReactComponent as TpoLogo } from "resources/tpo-logo.svg";
import { HiOutlineSpeakerphone } from "react-icons/hi";
import { primaryColor } from "resources/constants";
import ProfileComponent from "app/profile/ProfileComponent";
import athenaLogo from "resources/logo-no-letters.png";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as Assortment } from "resources/assortment-logo.svg";
import RecommendationDialogComponent from "app/recommendation-engine/RecommendationDialogComponent";
import { recommendationGetActionsRecommend } from "lib/requests/recommendationEngine";
import _ from "lodash";
import {
  setCacheScenario,
  setSelectedScenario,
  setReferenceScenario,
  setCacheReferenceScenario,
} from "app/scenarios/duck/slices";
import { getCycleTypeId } from "lib/utils/cycles";
import { currentDefaultScenario } from "lib/utils/scenarios";
import { changeSelectedScenarioAsyncAction } from "app/scenarios/duck/actions";
import AthenaMindIcon from "./AthenaMindIcon";

const useStyles = makeStyles({
  icon: {
    width: "22px",
    height: "22px",
    color: "white",
    "& > path": {
      stroke: "white",
      fill: "white",
    },
  },
  navIcon: {
    color: "inherit",
    marginTop: "0px",
  },
  bottomIconGroup: {
    position: "absolute",
    bottom: 20,
    // width: "100%",
    display: "flex",
    // flexDirection: "column",
    justifyContent: "center",
  },
  topIconGroup: {
    marginTop: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  menuItem: {
    color: "white",
    width: "100%",
    padding: "12px 0px 12px 25px",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
  },
  menuItemButton: {
    color: "white",
    width: "100%",
    padding: "12px 0px 12px 15px",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
  },
  bottomMenuItemButton: {
    color: "white",
    width: "100%",
    padding: "2px 0px 12px 15px",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
  },
  linkText: {
    marginLeft: "10px",
  },
  linkTextDisabled: {
    color: "gray",
    marginLeft: "10px",
  },
  activeLink: {
    boxShadow: "0 2px 3px 0px black",
    backgroundColor: primaryColor,
  },
  logo: {
    width: "100px",
    display: "block",
    margin: "0 auto",
    marginTop: "30px",
  },
  iconDisabled: {
    width: "22px",
    height: "22px",
    color: "gray",
  },
});

const StyledButton = withStyles(() => ({
  label: {
    justifyContent: "end",
  },
  root: {
    textTransform: "none",
    fontSize: "15px",
  },
}))(Button);

export default function TemporaryDrawer() {
  const classes = useStyles();
  const { url } = useRouteMatch();
  const dispatch = useDispatch();
  const scenariosSlice = useSelector((state) => state.scenarios);
  const cycleSlice = useSelector((state) => state.cycle);
  const catalogData = useSelector((state) => state.catalog);
  const areasData = useSelector((state) => state.areas);
  const retailersData = useSelector((state) => state.retailers);
  const user = useSelector((state) => state.auth.user);
  const storeTenant = useSelector((state) => state.auth.tenant);
  const [actionsRecommendWithLabels, setActionsRecommendWithLabels] = useState(
    []
  );
  const configCatSlice = useSelector((state) => state.auth.configCatUser);
  const [isErrorGettingData, setIsErrorGettingData] = useState(false);
  const [
    isRecommendationDialogOpen,
    setIsRecommendationDialogOpen,
  ] = React.useState(false);

  const handleRecommendationDialogClose = () => {
    setIsRecommendationDialogOpen(false);
  };

  const handleRecommendationDialogOpen = () => {
    setIsRecommendationDialogOpen(true);
  };

  useEffect(() => {
    const getActionsRecommend = async () => {
      const params = {
        path: user.username,
      };

      const differentFilters = [
        {
          id: "product",
          array: catalogData.products,
        },
        {
          id: "area",
          array: areasData,
        },
        {
          id: "retailer",
          array: retailersData,
        },
        {
          id: "line",
          array: catalogData.lines,
        },
        {
          id: "category",
          array: catalogData.categories,
        },
      ];

      const actionsRecommend = await recommendationGetActionsRecommend(params)
        .then((response) => {
          setIsErrorGettingData(false);
          if (response.data?.status_code === 404) {
            return response.data.message;
          }
          return response.data;
        })
        .catch(() => {
          setIsErrorGettingData(true);
        });
      /* eslint-disable no-param-reassign */
      if (
        !isErrorGettingData &&
        actionsRecommend &&
        Array.isArray(actionsRecommend)
      ) {
        actionsRecommend.forEach((action) => {
          differentFilters.forEach((filter) => {
            if (action[`${filter.id}_id`] !== null) {
              const findLabel = _.find(filter.array, (item) => {
                return item.id === action[`${filter.id}_id`];
              });
              if (findLabel?.label) {
                action[`${filter.id}_label`] = findLabel.label;
              } else {
                action[`${filter.id}_label`] = null;
              }
            } else {
              action[`${filter.id}_label`] = null;
            }
          });
        });
        /* eslint-enable no-param-reassign */
      }
      setActionsRecommendWithLabels(actionsRecommend);
    };
    if (isRecommendationDialogOpen) getActionsRecommend();
  }, [isRecommendationDialogOpen]);

  const isCycleTypeExist = (condition) => {
    return (
      _.find(
        cycleSlice.list,
        (cycle) => cycle.cycle_type_id === condition[0]?.id
      ) !== undefined
    );
  };

  const ifTypePricingExist = isCycleTypeExist(
    getCycleTypeId("Pricing", cycleSlice)
  );
  const ifTypeAnnualExist = isCycleTypeExist(
    getCycleTypeId("Pricing 2.0", cycleSlice)
  );
  const ifTypeTpoExist = isCycleTypeExist(
    getCycleTypeId("Trade Promotions", cycleSlice)
  );

  const handleOpenAthenaMind = async () => {
    try {
      const session = await Auth.currentSession();
      const idToken = session.getIdToken().getJwtToken();
      const accessToken = session.getAccessToken().getJwtToken();
      const refreshToken = session.getRefreshToken().getToken();

      const tenant = storeTenant;
      const scenario = scenariosSlice.selectedScenario;

      const athenaMindUrl = process.env.REACT_APP_ATHENAMIND_URL;
      const ssoWindow = window.open(`${athenaMindUrl}/sso`, "_blank");

      const isOriginAllowed = (origin, allowedOrigins) => {
        return allowedOrigins.some((allowedOrigin) => {
          if (
            typeof allowedOrigin === "string" &&
            allowedOrigin.includes("*")
          ) {
            const regexStr = `^${allowedOrigin
              .replace(/\./g, "\\.")
              .replace(/\*/g, "[a-zA-Z0-9-.]+")}$`;
            return new RegExp(regexStr).test(origin);
          }
          return allowedOrigin === origin;
        });
      };

      const handleMessage = (event) => {
        const envAllowedOrigins = process.env
          .REACT_APP_ATHENAMIND_ALLOWED_ORIGINS
          ? process.env.REACT_APP_ATHENAMIND_ALLOWED_ORIGINS.split(
              ","
            ).map((o) => o.trim())
          : [];
        const allowedOrigins = [athenaMindUrl, ...envAllowedOrigins].filter(
          Boolean
        );
        if (!isOriginAllowed(event.origin, allowedOrigins)) return;

        if (event.data?.type === "SSO_READY") {
          const messageContent = {
            type: "SSO_PAYLOAD",
            payload: {
              idToken,
              accessToken,
              refreshToken,
              tenant: tenant
                ? {
                    id: tenant.id,
                    mysql_database: tenant.mysql_database,
                    company: tenant.company,
                  }
                : null,
              scenario: scenario
                ? {
                    scenario_id: scenario.scenario_id,
                    name: scenario.name,
                    cycle_type: scenario.cycle_type,
                  }
                : null,
            },
          };
          ssoWindow.postMessage(messageContent, event.origin);

          window.removeEventListener("message", handleMessage);
        }
      };

      window.addEventListener("message", handleMessage);

      setTimeout(() => {
        window.removeEventListener("message", handleMessage);
      }, 30000);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error opening Athena Mind:", error);
    }
  };

  const handleCurrentScenario = (cycleLabelType) => {
    // If we don't have scenario set in cache means that we don't have scenario selected for the cycleType specified.
    if (_.isEmpty(scenariosSlice.setCacheScenario[cycleLabelType])) {
      const selectedScenarioTotal = currentDefaultScenario(
        cycleLabelType,
        scenariosSlice.totalsByScenarioId,
        cycleSlice
      );
      // Finally, we need to request the scenario estimations to the server and set the current scenario selected and set the specific scenario type selected.
      dispatch(
        changeSelectedScenarioAsyncAction(selectedScenarioTotal?.scenario_id)
      );
      dispatch(
        setCacheScenario({
          [cycleLabelType]: selectedScenarioTotal,
        })
      );
      dispatch(
        setCacheReferenceScenario({
          [cycleLabelType]: selectedScenarioTotal,
        })
      );
      // If we have scenario selected for this cycle and the scenario selected is not equal to the cache scenario we need to change the selected scenario.
    } else if (
      scenariosSlice.setCacheScenario[cycleLabelType].scenario_id !==
      scenariosSlice.selectedScenario.scenario_id
    ) {
      dispatch(
        setSelectedScenario(scenariosSlice.setCacheScenario[cycleLabelType])
      );
      dispatch(
        setReferenceScenario(
          scenariosSlice.setCacheReferenceScenario[cycleLabelType]
        )
      );
    }
  };

  const handleMultipleCycles = () => {
    if (ifTypePricingExist) {
      handleCurrentScenario("Pricing");
    } else {
      handleCurrentScenario("Pricing 2.0");
    }
  };

  const handleTpoOrDailytpCycles = () => {
    if (_.isEmpty(scenariosSlice.setCacheScenario["Daily Trade Promotions"])) {
      handleCurrentScenario("Trade Promotions");
    } else {
      handleCurrentScenario("Daily Trade Promotions");
    }
  };

  return (
    <div>
      <img
        className={classes.logo}
        src={athenaLogo}
        alt="Athena logo"
        data-testid="mobileAthenaLogo"
      />
      <div className={classes.topIconGroup}>
        <Tooltip title="TPo" placement="right">
          {ifTypeTpoExist ? (
            <NavLink
              exact
              to={`${url}`}
              className={classes.menuItem}
              activeClassName={classes.activeLink}
              onClick={() => handleTpoOrDailytpCycles()}
            >
              <TpoLogo
                data-testid="mobileTpoScenariosIcon"
                component={NavLink}
                className={`${classes.icon} ${classes.navIcon}`}
                fill="white"
              />
              <span className={classes.linkText}>TPo</span>
            </NavLink>
          ) : (
            <Box className={classes.menuItem}>
              <TpoLogo
                data-testid="mobileTpoScenariosIcon"
                component={NavLink}
                className={`${classes.iconDisabled} ${classes.navIcon}`}
                fill="gray"
              />
              <span className={classes.linkTextDisabled}>TPo</span>
            </Box>
          )}
        </Tooltip>
        <Tooltip title="Pricing" placement="right">
          {ifTypePricingExist || ifTypeAnnualExist ? (
            <NavLink
              exact
              to={`${url}/pricing`}
              className={classes.menuItem}
              activeClassName={classes.activeLink}
              onClick={() => handleMultipleCycles()}
            >
              <RiPriceTag3Line
                data-testid="mobilePriceScenariosIcon"
                component={NavLink}
                className={`${classes.icon} ${classes.navIcon}`}
              />
              <span className={classes.linkText}>Pricing</span>
            </NavLink>
          ) : (
            <Box className={classes.menuItem}>
              <RiPriceTag3Line
                data-testid="mobilePriceScenariosIcon"
                component={NavLink}
                className={`${classes.iconDisabled} ${classes.navIcon}`}
              />
              <span className={classes.linkTextDisabled}>Pricing</span>
            </Box>
          )}
        </Tooltip>
        <Tooltip title="Competitors" placement="right">
          <NavLink
            to={`${url}/competitors`}
            className={classes.menuItem}
            activeClassName={classes.activeLink}
          >
            <BsArrowsAngleContract
              data-testid="mobileCompetitorsIcon"
              component={NavLink}
              className={`${classes.icon} ${classes.navIcon}`}
            />
            <span className={classes.linkText}>Competitors</span>
          </NavLink>
        </Tooltip>
        <Tooltip title="Elasticity" placement="right">
          <NavLink
            to={`${url}/elasticity`}
            className={classes.menuItem}
            activeClassName={classes.activeLink}
          >
            <RiBubbleChartLine
              data-testid="mobileElasticityIcon"
              component={NavLink}
              className={`${classes.icon} ${classes.navIcon}`}
            />
            <span className={classes.linkText}>Elasticity</span>
          </NavLink>
        </Tooltip>
        <Tooltip title="History" placement="right">
          <NavLink
            to={`${url}/history`}
            className={classes.menuItem}
            activeClassName={classes.activeLink}
          >
            <RiHistoryLine
              data-testid="mobileHistoryIcon"
              component={NavLink}
              className={`${classes.icon} ${classes.navIcon}`}
            />
            <span className={classes.linkText}>History</span>
          </NavLink>
        </Tooltip>
        <Tooltip title="Available soon" placement="right">
          <NavLink
            to={`${url}/demand`}
            className={classes.menuItem}
            activeClassName={classes.activeLink}
          >
            <RiCalendar2Line
              data-testid="mobileDemandIcon"
              component={NavLink}
              className={`${classes.icon} ${classes.navIcon}`}
            />
            <span className={classes.linkText}>Demand Planning</span>
          </NavLink>
        </Tooltip>
        {configCatSlice?.features?.athenamind ? (
          <Tooltip title="Athena Mind" placement="right">
            <StyledButton
              onClick={handleOpenAthenaMind}
              className={classes.menuItemButton}
            >
              <AthenaMindIcon
                className={`${classes.icon} ${classes.navIcon}`}
              />
              <span className={classes.linkText}> Athena Mind</span>
            </StyledButton>
          </Tooltip>
        ) : null}
        <Tooltip title="Available soon" placement="right">
          <Box className={classes.menuItem}>
            <Assortment
              fill="gray"
              className={`${classes.iconDisabled} ${classes.navIcon}`}
            />
            <span className={classes.linkTextDisabled}>Assortment</span>
          </Box>
        </Tooltip>
        <Tooltip title="Available soon" placement="right">
          <Box className={classes.menuItem}>
            <HiOutlineSpeakerphone
              className={`${classes.iconDisabled} ${classes.navIcon}`}
            />
            <span className={classes.linkTextDisabled}>Newscast</span>
          </Box>
        </Tooltip>
        <RecommendationDialogComponent
          open={isRecommendationDialogOpen}
          handleClose={handleRecommendationDialogClose}
          actionsRecommend={actionsRecommendWithLabels}
          isErrorGettingData={isErrorGettingData}
        />
        {configCatSlice?.features?.IsRecommendationEngineEnabled ? (
          <Tooltip title="Recommendation Engine" placement="right">
            <StyledButton
              onClick={() => handleRecommendationDialogOpen()}
              className={classes.menuItemButton}
            >
              <FaHandshake className={`${classes.icon} ${classes.navIcon}`} />
              <span className={classes.linkText}> Recommendation Engine</span>
            </StyledButton>
          </Tooltip>
        ) : null}
      </div>
      <div className={classes.bottomIconGroup}>
        <div className={classes.bottomMenuItemButton}>
          <ProfileComponent className={classes.icon} />
        </div>
      </div>
    </div>
  );
}
